// src/App.tsx
import { Title } from '@gjensidige/builders-components';
import React from 'react';
import { CarForm } from './forms/CarForm';
import CarTravelSpringSummer from './images/CarTravelSpringSummer.webp';
import CarTravelSpringSummerSmall from './images/CarTravelSpringSummerSmall.webp';

export const App: React.FC = () => {

  return (
    <header className="calculation-header">
      <div className="wrapper">
        <div className="background-img-wrapper">
          <picture>
            <source
              media="(min-width: 50em)"
              srcSet={CarTravelSpringSummer}
            />
            <img
              src={CarTravelSpringSummerSmall}
              alt="Ett par som packar en bil inför en resa en solig dag"
              // @ts-ignore due to react-bug
              fetchpriority="high"
              loading="eager"
            />
          </picture>
        </div>
        <div className="content">
          <Title as='h1' uppercase={true} size="3">
            Se pris och köp din bilförsäkring
          </Title>
          <CarForm />
        </div>
      </div>
    </header>
  );
};